<template>
  <b-container>
    <Spinner size="32" message="Loading..." style="margin:0,auto" v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-table
      show-empty
      selectable
      select-mode="single"
      head-variant="dark"
      empty-text="No Disbursal available."
      stacked="md"
      bordered
      striped
      :items="claims"
      :fields="fields"
      style="font-size:12px"
    >
      <template v-slot:cell(action)="row">
        <a target="_blank" :href="getImgUrl(row.item)">View</a>
      </template>
      <template v-slot:cell(schedule)="row">
        <a
          target="_blank"
          :href="getImgUrl2(row.item)"
          v-if="row.item.UploadAmortizationSchedule !=''"
        >EMI</a>
      </template>
    </b-table>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
export default {
  components: { Spinner },
  props: ["UserID"],
  data() {
    return {
      isLoading: false,
      alertText: "",
      showDismissibleAlert: false,
      variant: "danger",
      claims: [],
      fields: [
        { key: "LoanBank", label: "Loan Bank", sortable: true },
        { key: "LoanBranch", label: "Loan Branch", sortable: true },
        { key: "DisburmentAmount", label: "Disbursed Amount", sortable: true },
        { key: "DisbursalDate", label: "Disbursal Date", sortable: true },
        { key: "TrancheNo", label: "Tranche No", sortable: true },
        { key: "TotalDisbursal", label: "Total Disbursal", sortable: true },
        { key: "EmiAmount", label: "EMI Amount", sortable: true },
        { key: "ROI", label: "ROI%", sortable: true },
        { key: "LoanTenure", label: "Tenure (months)", sortable: true },
        {
          key: "EmiStartDate",
          label: "EMI Start Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        {
          key: "EmiEndDate",
          label: "EMI End Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "action", label: "View" },
        { key: "schedule", label: "Schedule" }
      ]
    };
  },
  watch: {
    UserID: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getDisbursals();
      }
    }
  },
  methods: {
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.UserID +
          "/" +
          pic.UploadDisburmentLetter
        );
      }
    },
    getImgUrl2(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.UserID +
          "/" +
          pic.UploadAmortizationSchedule
        );
      }
    },
    getDisbursals() {
      this.isLoading = true;
      this.showDismissibleAlert = false;

      let promise = apis.ReadDisbursementByQuery({
        UserLoginID: this.UserID,
        LoanType: 1
      });

      promise
        .then(response => {
          //console.log("DL", response);
          if (response.status == 200) {
            this.claims = response.body;
            this.totalRows = this.claims.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      //console.log(this.selectedDistrict);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/ClaimComponents/DisbursalDetails.vue